import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { AuthStore } from '../stores/auth.store';
import { DashboardRoute } from '../../../dashboard/common/enums/dashboard-route';
import type { BusinessModule } from '../enums/business/business-module';

export const moduleGuard = (module: BusinessModule): CanActivateFn => {
  return () => {
    const authStore = inject(AuthStore);
    const router = inject(Router);

    return authStore.hasModule(module)
      ? true
      : router.createUrlTree([DashboardRoute.ORDERS]);
  };
};
